import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type Debt = {
    internalId: string;
    creditorName?: string;
    currentBalance?: {
        amount: number;
        currency: string;
    };
    nominalInterestRate?: number;
    accountType: 'REPAYMENT_LOANS' | 'CHARGE_CARDS' | 'CREDIT_FACILITY';
    tenor?: number;
    nonSelectable?: boolean;
};
export type DebtsResponse = {
    debts: Debt[];
};

export const getDebtsService = async (
    apiProxyPath: string,
    apiKey: string,
    publicId: string,
    applicantType: 'MAIN' | 'CO',
    authenticationData?: AuthenticationData,
): Promise<DebtsResponse> => {
    return apiClient<DebtsResponse>(`${apiProxyPath}/debts`, {
        method: 'POST',
        body: { publicId, applicantType },
        apiKey,
        authenticationData,
        sentryTag: 'get_debts',
        sentryExtra: { applicantType },
    });
};
